import Vue from 'vue'
import MarqueeInstall from './install'

Vue.use(MarqueeInstall)
